import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Document } from '../classes/document';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class DocumentService {
    API_DOCUMENT_URL = config.serverAddress + ':' + config.serverPort + '/document/';

    constructor(private http: HttpClient) { }

    getAllByIDRequest(idRequest: string | null) {
        return this.http.get(this.API_DOCUMENT_URL + 'request/' + idRequest);
    }
    getAllByIDCustomer(idCustomer: string | null) {
        return this.http.get(this.API_DOCUMENT_URL + 'customer/' + idCustomer);
    }
    uploadExportFile(idRequest: string | null) {
        return this.http.get(this.API_DOCUMENT_URL + 'export/' + idRequest);
    }
    downloadDocumentsToSign(idRequest: string | null) {
        return this.http.get(this.API_DOCUMENT_URL + 'output/' + idRequest, { responseType: 'blob'});
    }
    downloadRecapDocument(idRequest: string | null) {
        return this.http.get(this.API_DOCUMENT_URL + 'recap/' + idRequest, { responseType: 'blob'});
    }
    create(formData: FormData) {
        return this.http.post<Array<Document>>(this.API_DOCUMENT_URL + 'create', formData);
    }
    copy(
        idRequestSource: string,
        idRequestDestination: string,
        idFolderGoogleDrive: string,
        options?: { skipDocumentTypeIds?: number[] }
    ) {
        const skipDocumentTypeIds = options?.skipDocumentTypeIds || [];
        return this.http.post<Array<Document>>(this.API_DOCUMENT_URL + 'copy', {
            IDRequestSource: idRequestSource,
            IDRequestDestination: idRequestDestination,
            IDFolderGoogleDrive: idFolderGoogleDrive,
            SkipDocumentTypeIDs: skipDocumentTypeIds
        });
    }
    /**
     * Per i tipi condivisi cliente (1,2,4,8,16,29):
     * per ogni master del customer senza satellite su questa pratica,
     * copia il file nella cartella Drive della pratica e crea/aggiorna il satellite.
     */
    syncCustomerDocumentsToRequest(payload: {
        IDRequest: number;
        IDCustomer: number;
        IDFolderGoogleDrive?: string | null;
        IDFolderGoogleDriveSecondary?: string | null;
    }) {
        return this.http.post<Array<Document>>(this.API_DOCUMENT_URL + 'sync-customer', payload);
    }
    /** Cancella il master del cliente: non tocca i satelliti delle pratiche. */
    deleteCustomerMaster(id: number | undefined) {
        return this.http.delete(this.API_DOCUMENT_URL + 'delete/customer/' + id);
    }
    deleteRequestDocument(id: number | undefined) {
        return this.http.delete(this.API_DOCUMENT_URL + 'delete/request/' + id);
    }
}
